import React, { Component } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import { createBrowserHistory } from "history";
import { Container } from "reactstrap";

import * as ROUTES from "../../../_constants/RouteVariables";

//.....................ADMIN COMPONENTS................../

import { CNavBar } from "./AdminHorizontalMenu";
import SideMenuComponent from "./AdminSideMenus";
import ManageInterests from "../Interests/ManageInterests";
import ManageCategories from "../Categories/ManageCategory";
import ManageInstructor from "../Instructors/ManageInstructor";
import ManageActivity from "../Activities/ManageActivity";
import ManageAdminDashBoard from "../AdminDashBoard/ManageAdminDashBoard";
import ManageAdminVerifiedContent from "../AdminVerifiedContent/ManageAdminVerifiedContents";
import ViewVerifiedContent from "../AdminVerifiedContent/ViewVerifiedContent";
import ManageEvent from "../Events/ManageEvent";
import AdminViewSpecificContent from "../AdminDashBoard/ApprovePublishContent";
import ManageEventAttendees from "../Events/EventsAttendees/ManageEventAttendees";
import ManageBanners from "../BANNERAD/ManageBanner";
import ManageFoodLibrary from "../FoodLibrary/ManageFoodLibrary";
import ManagePendingMealPlanTable from "../AdminPublishedMealPlans/ManagePendingMealPlanTable";
import AdminViewSpecificMealPLan from "../AdminPublishedMealPlans/ViewSpecificMealPLan";
//...........USER COMPONENTS...................//
import ManageUserDraft from "../Users/draftContents/ManageUserDraftContents";
import ManageUserPublication from "../Users/publishedContents/ManageUserPublishedContents";
import ManageUpLoadContent from "../Users/uploadContents/ManageUpLoadContents";
import ViewSpecificContent from "../Users/publishedContents/ViewSpecificContents";
import ManageMealPlan from "../MealPlan/ManagedMealPlan";
import ManagePublishedMealPlanTable from "../Users/publishedMealPlans/ManagePublishedMealPlanTable";
import ManageDraftMealPlanTable from "../Users/draftMealPlans/ManageDraftMealPlanTable";
import ViewSpecificMealPLan from "../Users/publishedMealPlans/viewSpecificPublishedMealPlans";
import EditMealPlanManager from "../Users/draftMealPlans/EditMealPlanManager";
import InstructorManagedFoodLibrary from "../FoodLibrary/InstructorManagedFoodLibrary";
import ManageMealConfigs from "../../MealConfigurations/ManagedMealConfigs";
import "./MainApp.scss";
import ManageAllMealPlans from "../Users/manageMealPlans/ManageAllMealPlans";
//....................ERROR HANDLING.................//
import RouteError from "../../Errors/RoutesErrors";
import ManageDealCategories from "../DealsCategory/ManageDealCategories";
import ManageMerchants from "../Merchants/ManageMerchants";
import ManageMerchantLocations from "../MerchantsLocation/ManageMerchantLocations";
import ManageDeals from "../Deals/ManageDeals";

export const history = createBrowserHistory();
class MainApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFullWidth: false,
            headerName: null,
            userRole: null,
        };
        this.showHeader = this.showHeader.bind(this);
    }

    toggleFullWidth = () => {
        this.setState((prevState) => ({
            isFullWidth: !prevState.isFullWidth,
        }));
    };

    showHeader(data) {
        this.setState({ headerName: data });
    }

    render() {
        const { location, role } = this.props;
        const { isFullWidth, headerName } = this.state;

        if (role === "ROLE_VLA_INSTRUCTOR") {
            return (
                <Router history={history}>
                    <div>
                        <SideMenuComponent isFullWidth={isFullWidth} location={location} showHeader={this.showHeader} role={role} />
                        <main className={`main-content ${isFullWidth ? "active" : ""}`}>
                            <CNavBar toggleFullWidth={this.toggleFullWidth} title={headerName} role={role} />
                            <Container className="innerContent" fluid>
                                <Switch>
                                    <Route exact={true} path={ROUTES.UserPublishedContents} name="PublishContents" component={ManageUserPublication} />
                                    <Route exact={true} path={ROUTES.UserDrafts} name="Drats" component={ManageUserDraft} />
                                    <Route exact={true} path={ROUTES.UserUploadContents} component={ManageUpLoadContent} />
                                    <Route exact={true} path={ROUTES.UserSpecificContents} component={ViewSpecificContent} />
                                    <Route exact={true} path={ROUTES.MealPLanPage} component={ManageMealPlan} />
                                    <Route exact={true} path={ROUTES.PublishMealPlans} component={ManagePublishedMealPlanTable} />
                                    <Route exact={true} path={ROUTES.DraftMealPlans} component={ManageDraftMealPlanTable} />
                                    <Route exact={true} path={ROUTES.ManageAllMealPlansPage} component={ManageAllMealPlans} />
                                    <Route exact={true} path={ROUTES.viewSpecificMealPlans} component={ViewSpecificMealPLan} />
                                    <Route exact={true} path={ROUTES.AdminFoodLibrary} component={InstructorManagedFoodLibrary} />
                                    <Route exact={true} path={ROUTES.UserEditMealPlan} component={EditMealPlanManager} />
                                    <Redirect to="/dashboard" />
                                </Switch>
                            </Container>
                        </main>
                    </div>
                </Router>
            );
        } else if (role === "ROLE_VLA_ADMIN") {
            return (
                <Router history={history}>
                    <div>
                        <SideMenuComponent isFullWidth={isFullWidth} location={location} showHeader={this.showHeader} role={role} />
                        <main className={`main-content ${isFullWidth ? "active" : ""}`}>
                            <CNavBar toggleFullWidth={this.toggleFullWidth} title={headerName} role={role} />
                            <Container className="innerContent" fluid>
                                <Switch>
                                    <Route exact={true} path={ROUTES.AdminVerifiedDashBoard} component={ManageAdminVerifiedContent} />

                                    <Route exact={true} path={ROUTES.ManageAdminDashBoard} component={ManageAdminDashBoard} />

                                    <Route exact={true} path={ROUTES.ApprovedContents} component={AdminViewSpecificContent} />
                                    <Route exact={true} path={ROUTES.AdminCreateCategories} component={ManageCategories} />

                                    <Route exact={true} path={ROUTES.AdminManageUserProfile} component={ManageInstructor} />

                                    <Route exact={true} path={ROUTES.AdminEvents} component={ManageEvent} />

                                    <Route exact={true} path={ROUTES.ViewEventsAttendees} component={ManageEventAttendees} />

                                    <Route exact={true} path={ROUTES.CreateActivities} component={ManageActivity} />

                                    <Route exact={true} path={ROUTES.ManageMerchantsPage} component={ManageMerchants} />

                                    <Route exact={true} path={ROUTES.ManageDealsCategoryPage} component={ManageDealCategories} />

                                    <Route exact={true} path={ROUTES.ManageDealsPage} component={ManageDeals} />

                                    <Route exact={true} path={ROUTES.ManageMerchantLocationPage} component={ManageMerchantLocations} />

                                    <Route exact={true} path={ROUTES.CreateInterest} component={ManageInterests} />

                                    <Route exact={true} path={ROUTES.AdminViewVerifiedContent} component={ViewVerifiedContent} />
                                    <Route exact={true} path={ROUTES.AdminBanner} component={ManageBanners} />

                                    <Route exact={true} path={ROUTES.AdminFoodLibrary} component={ManageFoodLibrary} />

                                    <Route exact={true} path={ROUTES.AdminViewPendingMealPlans} component={ManagePendingMealPlanTable} />

                                    <Route exact={true} path={ROUTES.MealPlansConfigs} component={ManageMealConfigs} />

                                    <Route exact={true} path={ROUTES.AdminViewSpecificDailyMealPlans} component={AdminViewSpecificMealPLan} />
                                    <Redirect to="/dashboard" />
                                </Switch>
                            </Container>
                        </main>
                    </div>
                </Router>
            );
        } else {
            return (
                <Router history={history}>
                    <div>
                        <SideMenuComponent isFullWidth={isFullWidth} location={location} showHeader={this.showHeader} role={role} />
                        <main className={`main-content ${isFullWidth ? "active" : ""}`}>
                            <CNavBar toggleFullWidth={this.toggleFullWidth} title={headerName} />
                            <Container className="innerContent" fluid>
                                <Switch>
                                    <Route exact={true} path={ROUTES.ErrorPage} component={ManageAdminDashBoard} />
                                    <Route component={RouteError} />
                                </Switch>
                            </Container>
                        </main>
                    </div>
                </Router>
            );
        }
    }
}

export default MainApp;
